<template>
  <header class="header">
    <div class="container">
      <div class="header-inner">
        <div class="logo-container">
          <router-link to="/" class="logo">
            <img src="@/assets/logo.png" alt="俊采猎头" />
          </router-link>
          <div class="slogan">
            <span class="slogan-text">您身边的猎头顾问</span>
          </div>
        </div>
        
        <!-- 移动端导航按钮 -->
        <div class="mobile-nav-toggle visible-mobile" @click="toggleMobileNav">
          <i class="bi" :class="isMobileNavOpen ? 'bi-x' : 'bi-list'"></i>
        </div>
        
        <nav class="main-nav" :class="{'active': isMobileNavOpen}">
          <ul class="nav-list">
            <li class="nav-item">
              <router-link to="/" class="nav-link" @click="closeMobileNav">首页</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/about" class="nav-link" @click="closeMobileNav">关于我们</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/business" class="nav-link" @click="closeMobileNav">服务项目</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/clients" class="nav-link" @click="closeMobileNav">成功案例</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/contact" class="nav-link" @click="closeMobileNav">联系我们</router-link>
            </li>
          </ul>
        </nav>
        
        <!-- 热线电话 -->
        <div class="hotline hidden-mobile">
          <a href="tel:021-63806309" title="猎头咨询热线">
            <i class="bi bi-telephone-fill"></i>
            <span>021-63806309</span>
          </a>
        </div>
        
        <!-- 移动端电话图标 -->
        <a href="tel:021-63806309" class="mobile-phone visible-mobile" title="点击直拨猎头咨询热线">
          <i class="bi bi-telephone-fill"></i>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
      isMobileNavOpen: false,
      // 保存事件处理函数引用，便于卸载时正确移除，避免内存泄漏
      handleResize: null,
      handleOutsideClick: null
    };
  },
  methods: {
    toggleMobileNav() {
      this.isMobileNavOpen = !this.isMobileNavOpen;
      document.body.style.overflow = this.isMobileNavOpen ? 'hidden' : '';
    },
    closeMobileNav() {
      if (this.isMobileNavOpen) {
        this.isMobileNavOpen = false;
        document.body.style.overflow = '';
      }
    }
  },
  mounted() {
    this.handleResize = () => {
      if (window.innerWidth > 768 && this.isMobileNavOpen) {
        this.isMobileNavOpen = false;
        document.body.style.overflow = '';
      }
    };

    // 关闭导航菜单当点击外部区域
    this.handleOutsideClick = (e) => {
      if (this.isMobileNavOpen && !this.$el.contains(e.target)) {
        this.closeMobileNav();
      }
    };

    window.addEventListener('resize', this.handleResize, { passive: true });
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.handleOutsideClick);
    // 组件卸载时恢复 body 滚动，避免遗留 overflow:hidden
    document.body.style.overflow = '';
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.container {
  height: 100%;
  display: flex;
  justify-content: center;
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  max-width: 1200px;
  padding: 0 20px;
}

.logo-container {
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 20px;
}

.logo-container::after {
  content: '';
  position: absolute;
  right: 0;
  top: 15%;
  height: 70%;
  width: 1px;
  background: linear-gradient(to bottom, transparent, #e0e0e0, transparent);
  display: none;
}

@media (min-width: 992px) {
  .logo-container::after {
    display: block;
  }
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 50px;
  width: auto;
}

.slogan {
  display: flex;
  align-items: flex-end;
  margin-left: 12px;
  height: 50px;
  padding-bottom: 4px;
}

.slogan-text {
  font-size: 13px;
  color: #009688;
  white-space: nowrap;
  letter-spacing: 0.8px;
  font-weight: 500;
  position: relative;
  font-style: italic;
}

.slogan-text::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, transparent, #009688, transparent);
  opacity: 0.7;
}

.mobile-nav-toggle {
  display: none;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background-color: #009688;
  color: #fff;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  transition: all 0.3s ease;
  margin-left: auto;
}

.mobile-nav-toggle:hover {
  background-color: #00796b;
}

.main-nav {
  height: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav-list {
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.nav-item {
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 5px;
}

.nav-link {
  padding: 0 20px;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  letter-spacing: 0.5px;
}

.nav-link:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #009688, #4CAF50);
  transition: width 0.3s ease;
  border-radius: 3px;
}

.nav-link:hover {
  color: #009688;
}

.nav-link:hover:after,
.router-link-active:after {
  width: 80%;
}

.router-link-active {
  color: #009688;
  font-weight: 600;
}

.hotline {
  margin-left: 20px;
}

.hotline a {
  color: #009688;
  text-decoration: none;
  font-weight: bold;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.hotline i {
  margin-right: 8px;
  font-size: 20px;
}

.mobile-phone {
  display: none;
  font-size: 24px;
  color: #009688;
  margin-left: 15px;
}

/* 媒体查询 */
@media (max-width: 1023px) {
  .nav-link {
    padding: 0 12px;
    font-size: 15px;
  }
  
  .hotline a {
    font-size: 16px;
  }
  
  .hotline i {
    font-size: 18px;
  }
  
  .slogan-text {
    font-size: 12px;
  }
}

/* 添加新的媒体查询，处理中等屏幕尺寸 */
@media (max-width: 900px) and (min-width: 768px) {
  .header {
    height: 70px;
  }
  
  .logo img {
    height: 45px;
  }
  
  .nav-link {
    padding: 0 8px;
    font-size: 14px;
  }
  
  .nav-list {
    justify-content: center;
  }
  
  .hotline {
    margin-left: 10px;
  }
  
  .hotline a {
    font-size: 14px;
  }
  
  .hotline i {
    font-size: 16px;
    margin-right: 5px;
  }
}

@media (max-width: 767px) {
  .header {
    height: 70px;
  }
  
  .logo img {
    height: 40px;
  }
  
  .slogan-text {
    font-size: 11px;
  }
  
  .mobile-nav-toggle {
    display: flex;
    z-index: 1002;
    margin-left: auto;
  }
  
  .mobile-phone {
    display: block;
  }
  
  .main-nav {
    position: fixed;
    top: -100vh;
    left: 0;
    width: 100%;
    height: auto;
    max-height: 80vh;
    background-color: #fff;
    opacity: 1;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    transition: top 0.3s ease;
    z-index: 1001;
    padding-bottom: 20px;
    overflow-y: auto;
    flex: 0;
  }
  
  .main-nav.active {
    top: 70px;
    background-color: #fff;
  }
  
  .nav-list {
    flex-direction: column;
    align-items: center;
    height: auto;
    padding: 10px 0;
    width: 100%;
    background-color: #fff;
  }
  
  .nav-item {
    width: 90%;
    height: auto;
    margin: 5px 0;
  }
  
  .nav-link {
    width: 100%;
    padding: 15px 0;
    height: auto;
    border-bottom: 1px solid #f1f1f1;
    justify-content: center;
    border-radius: 4px;
    font-size: 16px;
    letter-spacing: 1px;
    transition: all 0.3s ease;
  }
  
  .nav-link:after {
    display: none;
  }
  
  .nav-link:hover,
  .router-link-active {
    background-color: rgba(0, 150, 136, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 3px 8px rgba(0, 150, 136, 0.1);
  }
  
  .router-link-active {
    color: #009688;
    font-weight: 600;
    border-left: 3px solid #009688;
  }
  
  /* 添加遮罩层 */
  .main-nav.active::before {
    content: '';
    position: fixed;
    top: 70px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: -1;
  }

  /* 调整移动端布局 */
  .header-inner {
    justify-content: space-between;
  }
  
  /* 确保电话图标在右侧 */
  .mobile-phone {
    margin-left: 10px;
  }
}

@media (max-width: 480px) {
  .logo-container {
    padding-right: 10px;
  }
  
  .slogan {
    margin-left: 8px;
  }
  
  .slogan-text {
    font-size: 10px;
    letter-spacing: 0.5px;
  }
  
  .nav-link {
    font-size: 15px;
    padding: 12px 0;
  }
}
</style> 